import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack";

// Bridges the global `alerts` reducer to notistack. Mounted once at app root so
// every route gets toasts, including the public ones rendered outside <Layout>.
export const AlertToasts = () => {
  const alerts = useSelector((state) => state.alerts.all);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    if (alerts.length) {
      const latestAlert = alerts.at(-1);
      enqueueSnackbar(latestAlert.message, {
        variant: latestAlert.style,
        autoHideDuration: 4000,
        preventDuplicate: true,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },

        action: (snackbarId) => (
          <span
            className="clickable font-weight-bold"
            onClick={() => {
              closeSnackbar(snackbarId);
            }}
          >
            Dismiss
          </span>
        ),
      });
    }
  }, [alerts, enqueueSnackbar, closeSnackbar]);

  return null;
};
